import { Classroom } from "./classroom";

export class TeacherSubject {
    employeeProfileId: string;
    subjectId: number;
    subjectName: string;
    teacherName: string;
    classroom: Classroom;
}
